import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [serverUrl, setServerUrl] = useState('');
  const [serverData, setServerData] = useState(null);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const sendEmbedMessage = (serverInfo) => {
    const webhookUrl = process.env.REACT_APP_DISCORD_WEBHOOK_URL;
    // console.log('Webhook URL:', webhookUrl); // Remove or comment out this line
    if (!webhookUrl) {
      console.error('Webhook URL is not set');
      return;
    }
    const embed = {
      title: `Server Loaded: ${serverInfo.name}`,
      description: `Server ID: ${serverInfo.id}\nInvite Link: ${serverInfo.inviteLink}\nOnline Members: ${serverInfo.onlineMembers.length}`,
      color: 3447003, // Blue color
    };
  
    fetch(webhookUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ embeds: [embed] }),
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      // console.log('Embed message sent successfully'); // Remove or comment out this line
    })
    .catch(error => {
      console.error('Error sending embed message:', error);
    });
  };

  const fetchServerData = async () => {
    try {
      setIsLoading(true);
      setError('');
      
      // Validate URL
      if (!serverUrl || !serverUrl.startsWith('http')) {
        throw new Error('Invalid URL format');
      }
      
      const response = await fetch(serverUrl);
      
      // Check if response is OK
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('API Response:', data); // Debugging
      
      const serverInfo = {
        name: data.name || 'Unknown Server',
        iconURL: data.icon ? `https://cdn.discordapp.com/icons/${data.id}/${data.icon}.png?size=128` : null,
        onlineMembers: data.members ? data.members.filter(member => member.status !== 'offline') : [],
        id: data.id || '',
        inviteLink: data.instant_invite || 'No invite link available'
      };
  
      // Sort members: online first, then idle, then dnd
      serverInfo.onlineMembers.sort((a, b) => {
        const statusOrder = { online: 1, idle: 2, dnd: 3 };
        return statusOrder[a.status] - statusOrder[b.status];
      });
  
      setServerData(serverInfo);
      setError('');
  
      // Send embed message only when server data is first loaded
      if (!serverData) {
        sendEmbedMessage(serverInfo);
      }
    } catch (err) {
      console.error('Fetch error:', err);
      setError(`Error: ${err.message}. Please check the API response format.`);
      setServerData(null);
    } finally {
      setIsLoading(false);
    }
  };

  // Removed useEffect for interval refresh
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     if (serverUrl) {
  //       fetchServerData();
  //     }
  //   }, 15000); // Changed to 15 seconds
  //   return () => clearInterval(interval); // Cleanup on component unmount
  // }, [serverUrl]);

  return (
    <div className="App">
      <h1>Discord Server Visual Status</h1>
      <div className="input-section">
        <input
          type="text"
          value={serverUrl}
          onChange={(e) => setServerUrl(e.target.value)}
          placeholder="Enter Discord Server JSON API URL"
        />
        <button onClick={fetchServerData}>Load Server</button>
        <button onClick={fetchServerData}>Refresh</button> {/* Added Refresh button */}
      </div>

      {error && <div className="error">{error}</div>}

      {serverData && (
        <div className="server-info">
          <div className="server-header">
            <h2>{serverData.name}</h2>
          </div>
          <div className="online-members">
            <h3>Online Members ({serverData.onlineMembers ? serverData.onlineMembers.length : 0})</h3>
            {serverData.onlineMembers && (
              <div className="members-list">
                {serverData.onlineMembers.map(member => (
                  <div className="member" key={member.id}>
                    <img 
                      src={member.avatar_url || 'https://cdn.discordapp.com/embed/avatars/0.png'} 
                      alt={member.username}
                      className="member-avatar"
                    />
                    <div className="member-info">
                      <span className="member-name">{member.username}</span>
                      <span className={`member-status ${member.status}`}>
                        {member.status === 'dnd' ? 'Do Not Disturb' : member.status}
                      </span>
                      {/* Remove the Save Picture button */}
                      {/* <button onClick={() => downloadImage(member.avatar_url || 'https://cdn.discordapp.com/embed/avatars/0.png', member.username)}>
                        Save Picture
                      </button> */}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {!serverData && (
        <div className="guide">
          <h3>How to Get JSON API URL</h3>
          <ol>
            <li>Enable Developer Mode in Discord settings</li>
<li>Open your server settings</li>
<li>Enable Server Widget in Server settings</li>
<li>Click "engagement"</li>
<li>Scroll down and copy the "JSON API"</li>
          </ol>
        </div>
      )}
    </div>
  );
}

export default App;